import { Action } from 'redux'
import { LimitActions } from '../../../reducers/userAccount/actionNames'
import { ILimit } from '../../../models/Limit'

const limitAccepted = (limit: ILimit): ILimitWasAccepted => ({
  limit,
  type: LimitActions.LimitsWasAccepted,
})

export default limitAccepted

export interface ILimitWasAccepted
  extends Action<LimitActions.LimitsWasAccepted> {
  limit: ILimit
}
